module.exports = __webpack_public_path__ + "img/chicken.295a1b91.jpg";